const BASE_URL = 'https://cannections.ca';
const DEFAULT_IMAGE = '/android-chrome-256x256.png';

const defaults = {
  title: 'Cannections | Connecting Cannabis Community',
  description:
    'Connect with cannabis users, discover strains, follow dispensaries, and explore cannabis culture with Cannections.',
  keywords:
    'cannabis, weed app, strain finder, dispensary, cannabis community, sativa, indica, hybrid, ottawa cannabis, canada weed',
  robots: 'index,follow',
  path: '/',
  type: 'website',
  image: DEFAULT_IMAGE,
};

const absoluteUrl = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_URL}${normalizedPath}`;
};

const upsertMetaByName = (name, content) => {
  if (!content) {
    return;
  }
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const upsertMetaByProperty = (property, content) => {
  if (!content) {
    return;
  }
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setCanonical = (url) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
};

export const setPageSeo = (page = {}) => {
  const seo = { ...defaults, ...page };
  const url = absoluteUrl(seo.path);
  const image = seo.image.startsWith('http')
    ? seo.image
    : absoluteUrl(seo.image);

  document.title = seo.title;
  setCanonical(url);

  upsertMetaByName('description', seo.description);
  upsertMetaByName('keywords', seo.keywords);
  upsertMetaByName('robots', seo.robots);
  upsertMetaByName('twitter:card', 'summary_large_image');
  upsertMetaByName('twitter:title', seo.title);
  upsertMetaByName('twitter:description', seo.description);
  upsertMetaByName('twitter:image', image);

  upsertMetaByProperty('og:type', seo.type);
  upsertMetaByProperty('og:url', url);
  upsertMetaByProperty('og:title', seo.title);
  upsertMetaByProperty('og:description', seo.description);
  upsertMetaByProperty('og:image', image);
  upsertMetaByProperty('og:site_name', 'Cannections');
};

export const setNoIndexPageSeo = (page = {}) =>
  setPageSeo({ ...page, robots: 'noindex,nofollow' });

